import { Parser } from './Parser.js';
import { DomHandler } from '../../../domhandler/lib/esm/index.js';
export { default as Tokenizer } from './Tokenizer.js';

// Helper methods
/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */
function parseDocument(data, options) {
    const handler = new DomHandler(undefined, options);
    new Parser(handler, options).end(data);
    return handler.root;
}

export { DomHandler as DefaultHandler, DomHandler, Parser, parseDocument };
//# sourceMappingURL=index.js.map
